export enum IsAlreadySellingPODAnswers {
  YesUsePODPartner = 'yes_use_pod_partner',
  YesUseSupplierOrProduceInHouse = 'yes_use_supplier_or_produce_in_house',
  No = 'no',
}
